<template>
    <div>
        <div class="content">
            <!-- BEGIN FORGOT PASSWORD FORM -->
            <form aria-label="Reset Password" class="forget-form">
                <div class="logo">
                    <a href="/public">
                        <img v-if="appLogo" :src="appLogo" :alt="project" class="logo-smart"
                             style="margin-top: -5px; margin-right: 5px; max-height:107px; max-width:300px;">
                        <span v-else>{{ project }}</span>
                    </a>
                </div>
                <h3 class="font-green">Reset Password</h3>
                <div class="alert alert-warning" :class="[ sent ? 'display-show' : 'display-hide' ]">
                    <span>We have e-mailed your password reset link!</span>
                </div>
                <div class="alert alert-danger" :class="[ errors.email.length ? 'display-show' : 'display-hide' ]">
                    <button class="close" type="button" @click="clearErrors(false)"></button>
                    <span v-for="(error, i) in errors.email" :key="i">{{ error }}</span>
                </div>
                <div v-if="!sent" class="form-group">
                    <label class="control-label visible-ie8 visible-ie9">Email</label>
                    <input class="form-control" :class="{'is-invalid': errors.email.length}" v-model="form.email"
                           type="email" placeholder="Email" name="email" @input="clearErrors('email')"
                           id="email" required autofocus>
                </div>
                <div class="form-actions">
                    <router-link :to="{ name: 'login' }" class="btn btn-default">Back</router-link>
                    <button v-if="!sent" @click.prevent="sendForm" type="button" class="btn green uppercase pull-right">Send Password Reset Link</button>
                </div>
            </form>
            <!-- END FORGOT PASSWORD FORM -->
        </div>
        <div class="copyright">© {{ new Date().getFullYear() }} {{ project }} {{ appType }}</div>
    </div>
</template>

<script>
import r from "@/js/route";
import httpClient from '@/js/services/http-client';

export default {
    name: "Email",

    data: () => ({
        pending: false,
        form: {
            email: '',
        },

        sent: false,

        errors: {
            email: [],
        },

        project: import.meta.env.VITE_APP_NAME,
        appType: import.meta.env.VITE_APP_TYPE,
        appLogo: import.meta.env.VITE_APP_LOGO_HEADER,
    }),

    methods: {
        sendForm() {
            if (this.pending === false) {
                this.pending = true;
                httpClient.post(r('password.email'), this.form)
                    .then(({ data }) => {
                        this.sent = true;
                    })
                    .catch(err => {
                        console.log(err.response.data.errors);

                        this.handleErrors(err.response.data.errors);
                    })
                    .then(() => {
                        this.pending = false;
                    });
            }
        },

        handleErrors(errors) {
            if (errors) {
                this.setErrors(errors)
            } else {
                this.clearErrors()
            }
        },

        setErrors(errors) {
            for (let key in this.errors) {
                if (Object.hasOwnProperty.call(this.errors, key)) {
                    this.errors[key] = errors[key] || []
                }
            }
        },

        clearErrors(key = false) {
            console.log(this.errors)
            if (key) {
                if (this.errors[key].length) {
                    this.errors[key] = []
                }
            } else {
                for (let key in this.errors) {
                    if (Object.hasOwnProperty.call(this.errors, key)) {
                        this.errors[key] = []
                    }
                }
            }
        }
    }
}
</script>

<style scope="scoped">

</style>
